import { gql } from '@apollo/client';

export const GET_PRODUCT_DETAILS = gql`
 query getProductDetails($input: productDetailsInput) {
  productDetails(input: $input) {
      applicableZones {
        code
        value
      }
      applicableTenures {
        code
        value
      }
      applicableCoverTypes {
        code
        value
      }
      applicableSumInsureds
      customApplicableSumInsureds {
        deductSumInsured
        sumInsured
      }
      applicableMemberTypes {
        label
        gender
        selectGender
        maxAllowed
      }
    }
    genderList {
      code
      value
    }
  }
`;

export const CALCULATE_PREMIUM = gql`
  query calculatePremiumForQuote($input: CalculatePremiumQuote) {
    calculatePremiumST(input: $input) {
      basePremium
      loadingDiscount
      netPremium
      gst
      stampDuty
      totalPremium
      loading {
        name
        amount
      }
      discount {
        name
        amount
      }
      breakup {
        relationship
        gender
        age
        premium
      }
    }
  }
`;
export const GET_PLAN_COVER_DETAILS = gql`
  query getPlanCoverDetails($input: planAndCoversInput) {
    planAndCovers(input: $input) {
      name
      code
      covers {
        name
        index
      }
      packs {
        name
        index
        addOnCovers {
          name
          index
          selected
        }
      }
    }
  }
`;
export const QUERY_STATE = gql`
  query healthQuotePlans {
    healthQuote @client
    healthPlans @client
    selectedIntermediary @client
  }
`;
